import { getCountries, getCountryCallingCode } from "libphonenumber-js";

// Catálogo de países para os campos de telefone.
//
// A lista não é escrita à mão de propósito: sai da própria libphonenumber-js,
// que é quem valida e formata o número depois. Mantida à mão, ela envelheceria
// separada da biblioteca — país novo, DDI que muda, e o seletor passaria a
// oferecer uma coisa que o formatador não reconhece.
//
// O nome vem do Intl do navegador, em pt-BR. Sem inventar tradução e sem mais
// um pacote só para isso.

const tradutor =
  typeof Intl !== "undefined" && Intl.DisplayNames
    ? new Intl.DisplayNames(["pt-BR"], { type: "region" })
    : null;

const nomeDoPais = (codigo) => {
  try {
    return tradutor?.of(codigo) || codigo;
  } catch {
    return codigo;
  }
};

export const PAISES = getCountries()
  .map((codigo) => ({
    codigo,
    nome: nomeDoPais(codigo),
    ddi: getCountryCallingCode(codigo),
  }))
  .sort((a, b) => a.nome.localeCompare(b.nome, "pt-BR"));

const PORTIPO = PAISES.reduce((acc, pais) => {
  acc[pais.codigo] = pais;
  return acc;
}, {});

export const buscarPais = (codigo) =>
  PORTIPO[String(codigo || "").toUpperCase()] || null;

// Busca sem acento e sem caixa: quem procura "sao tome" tem que achar
// "São Tomé e Príncipe". Digitar o DDI ("351") também encontra.
const semAcento = (texto) =>
  String(texto || "")
    .normalize("NFD")
    // Tira as marcas de acento que o NFD separou. Pela propriedade Unicode, e
    // não por faixa de código: a faixa exige caracteres invisíveis no fonte,
    // que não sobrevivem a toda ferramenta que toca no arquivo.
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();

export const filtrarPaises = (termo) => {
  const busca = semAcento(termo).trim();

  if (!busca) return PAISES;

  const digitos = busca.replace(/\D/g, "");

  return PAISES.filter(
    (pais) =>
      semAcento(pais.nome).includes(busca) ||
      pais.codigo.toLowerCase().includes(busca) ||
      (digitos && pais.ddi.startsWith(digitos)),
  );
};
